export const FILE_SIZE_LIMIT = 10000000; // ~ 10MB
